/*
 * @Author: zhoupeng 
 * @Date: 2018-09-18 13:58:32 
 * @Last Modified by: 吴文洁
 * @Last Modified time: 2019-10-09 13:22:04
 */

import Service from './Service';
import md5 from 'md5'
import User from "@/core/user";
class BenefitService {
  constructor(props) {
    this.PATH = {
      COUPON_STAT: 'public/coupon/getStudentCouponStat',
      COUPON_LIST: 'public/coupon/getStudentCouponPage',
      BENEFIT_STAT: 'c/student/my/stat',
      WHEAT_DETAIL: 'public/customerIntegral/getStuIntegral',

      COUPON_DETAIL: 'anon/coupon/getInstCouponDetail',
      COUPON_DETAIL_V2: 'public/coupon/getInstCouponDetail',
      STUDENT_COUPON_CHECk: 'anon/customerCoupon/checkInstStudent',
      STUDENT_COUPON_ADD: 'anon/customer/coupon/acquire',
      STUDENT_SIGNATURE: 'h/coupon/signature',
      COUPON_SAVE_CODE: 'h/coupon/save/code',

      XM_SHOW_LIST: 'public/customerShow/getForCustomerShowList',
      XM_SHOW_JOINED_LIST: 'public/customerShow/fetchAllMyJoinedXmShowList',
      REFERRAL_LIST: 'public/student/listReferral',
      REFERRAL_JOINED: 'public/student/listJoinedReferral',

      MARKETING_PERMISSION: 'public/institution/getMarketingPermission',

      COUPON_ISSUBSCRIBE: 'anon/referral/checkSubscribe',
      SEND_NOTIFY: 'anon/customerCoupon/sendReceiveNotify',

      SAVE_CLICK: 'anon/customerCoupon/saveClickNum'
    };
  }

  // 获取小麦粒，优惠券数量
  getBenefitStat() {
    const params = {
      instId: User.instId()
    };
    return Service.doAsyncRequest(this.PATH.BENEFIT_STAT, { params });
  }

  // 获取小麦粒数量
  getWheatDetail(params) {
    return axios.Sales(this.PATH.WHEAT_DETAIL, params);
  }

  // 优惠券列表统计
  getCouponStat() {
    const params = {
      instId: User.instId()
    };
    return axios.Customer(this.PATH.COUPON_STAT, params);
  }

  // 优惠券列表
  getCouponList(couponStatus, current, size) {
    const params = {
      couponStatus,
      current,
      size,
      instId: User.instId()
    };
    return axios.Customer(this.PATH.COUPON_LIST, params)
  }

  // 获取优惠券详情
  getCouponDetail(id) {
    const params = {
      couponId: id
    }
    return axios.Customer("anon/coupon/getInstCouponDetail", params);
  }

  // 新的获取优惠券详情
  getNewCouponDetail(couponId, studentId, tempToken) {
    const params = {
      couponId,
      studentId
    };
    const option = {
      tempToken,
      xmKey: md5(studentId + '-' + couponId),
      userType:'TEMP'
    }
    return axios.Customer(this.PATH.COUPON_DETAIL_V2, params, option);
  }

  // 检查是否存在机构学生
  studentCouponCheck(appId, openId, instId, couponId) {
    const params = {
      appId,
      openId,
      instId,
      couponId
    }
    return axios.Sales(this.PATH.STUDENT_COUPON_CHECk, params);
  }

  // 用户领取机构优惠券
  studentCoupenAdd(codeId, appId, openId, couponId, phone, name, referralId, promoterId) {
    const params = {
      codeId,
      appId,
      openId,
      couponId,
      phone: phone,
      referralId,
      promoterId
    }
    if (name) {
      params.name = name
    }
    return axios.Sales(this.PATH.STUDENT_COUPON_ADD, params);
  }

  couponSaveCode(studentCouponId, codeId) {
    const params = {
      studentCouponId,
      codeId
    }
    return Service.doAsyncRequest(this.PATH.COUPON_SAVE_CODE, { params });
  }

  // 获取签名等参数
  studentSignature(cardId) {
    const params = {
      cardId
    }
    return Service.doAsyncRequest(this.PATH.STUDENT_SIGNATURE, { params });
  }

  // 获取机构活动列表
  getInstActivtyList(instIds, current) {
    const params = {
      instIds,
      current,
      size: 10000,
    };
    return axios.Sales(this.PATH.XM_SHOW_LIST, params);
  }

  // 获取已参加机构活动列表
  getInstJoinedList(current) {
    const params = {
      current,
      size: 10
    }
    return axios.Sales(this.PATH.XM_SHOW_JOINED_LIST, params);
  }

  // 获取转介绍活动列表
  getShareActivtyList(pageNo) {
    const params = {
      status: 2,
      pageNo,
      pageSize: 10000
    }
    return axios.Customer(this.PATH.REFERRAL_LIST, params)
  }

  // 获取已参加转介绍活动列表
  getShareJoinedList(pageNo, openId) {
    const params = {
      pageNo,
      pageSize: 10,
      openId,
    }
    return axios.Customer(this.PATH.REFERRAL_JOINED, params)
  }

  // 会员营销权限
  getMarketingPermission() {
    return axios.Customer(this.PATH.MARKETING_PERMISSION)
  }

  //判断用户是否关注公众号
  checkIsSubscribe(openId, appId) {
    const params = {
      openId,
      appId
    }
    return axios.Sales(this.PATH.COUPON_ISSUBSCRIBE,params)
  }

  // 用户领取成功优惠券，发送公众号通知 SEND_NOTIFY
  sendNotify(couponId, phone, bannerUrl) {
    const params = {
      couponId,
      phone,
      bannerUrl
    }
    return axios.Sales(this.PATH.SEND_NOTIFY,params)
  }

  saveClick(id) {
    const params = { id }
    return axios.Sales(this.PATH.SAVE_CLICK,params)
  }

}

export default new BenefitService();



// WEBPACK FOOTER //
// ./src/service/BenefitService.js